import { useForm, Controller } from 'react-hook-form';
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Btn, H2, P } from '../../../../../AbstractElements';
import { dynamicImage } from '../../../../../Utils';
import { useRegister } from '../../../../../Auth/hooks/useRegister';
import {
  Agreewith,
  AlreadyHaveAccount,
  CreateAccount,
  EmailAddress,
  Href,
  Password,
  YourName,
  CreateYourAccount,
  SignIn,
} from '../../../../../Utils/Constants';

interface RegisterFormValues {
  firstname: string;
  lastname: string;
  email: string;
  password: string;
  terms: boolean;
  role: string; // added
}
interface RegisterFormProps {
    logoClass?: string;
}

export default function RegisterForm(props: RegisterFormProps) {
  const { handleRegister, loading } = useRegister();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<RegisterFormValues>({
    mode: 'onChange', // real-time validation
    defaultValues: {
      role: 'group leader',
    },
  });

  const onSubmit = (data: RegisterFormValues) => {
    const payload = {
      ...data,
      role: 'group leader', // enforce role
    };
    handleRegister(payload);
  };

  return (
    <div>
      <div>
        <Link className="logo" to="/">
          <img
            height={50}
            className="for-light"
            src={dynamicImage('logo/divine_comedy.webp')}
            alt="register"
          />
          <img
            height={50}
            className="for-dark"
            src={dynamicImage('logo/divine_comedy.webp')}
            alt="register"
          />
        </Link>
      </div>

      <div className="login-main">
        <Form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
          <H2 className="text-center">{CreateYourAccount}</H2>

          {/* Name Fields */}
          <FormGroup>
            <Col>
              <Label>{YourName}</Label>
            </Col>
            <Row className="g-2">
              <Col xs={6}>
                <Controller
                  name="firstname"
                  control={control}
                  rules={{ required: 'First name is required' }}
                  render={({ field }) => (
                    <Input type="text" placeholder="First name" {...field} />
                  )}
                />
                {errors.firstname && (
                  <P className="text-danger">{errors.firstname.message}</P>
                )}
              </Col>
              <Col xs={6}>
                <Controller
                  name="lastname"
                  control={control}
                  rules={{ required: 'Last name is required' }}
                  render={({ field }) => (
                    <Input type="text" placeholder="Last name" {...field} />
                  )}
                />
                {errors.lastname && (
                  <P className="text-danger">{errors.lastname.message}</P>
                )}
              </Col>
            </Row>
          </FormGroup>

          {/* Email Field */}
          <FormGroup>
            <Col>
              <Label>{EmailAddress}</Label>
            </Col>
            <Controller
              name="email"
              control={control}
              rules={{
                required: 'Email is required',
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: 'Invalid email format',
                },
              }}
              render={({ field }) => (
                <Input type="email" placeholder="Email" {...field} />
              )}
            />
            {errors.email && (
              <P className="text-danger">{errors.email.message}</P>
            )}
          </FormGroup>

          {/* Password Field */}
          <FormGroup>
            <Col>
              <Label>{Password}</Label>
            </Col>
            <Controller
              name="password"
              control={control}
              rules={{
                required: 'Password is required',
                minLength: {
                  value: 6,
                  message: 'Password must be at least 6 characters',
                },
              }}
              render={({ field }) => (
                <Input type="password" placeholder="Password" {...field} />
              )}
            />
            {errors.password && (
              <P className="text-danger">{errors.password.message}</P>
            )}
          </FormGroup>

          {/* Terms and Conditions */}
          <FormGroup className="mb-0 checkbox-checked">
            <FormGroup className="checkbox-solid-info" check>
              <Controller
                name="terms"
                control={control}
                rules={{
                  required: 'You must agree to the terms and conditions',
                }}
                render={({ field }) => (
                  <Input
                    type="checkbox"
                    checked={field.value || false}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                )}
              />
              <Label className="text-muted" check>
                {Agreewith}
              </Label>
              <a className="ms-3" href={Href}>
                Privacy Policy
              </a>
            </FormGroup>
            {errors.terms && (
              <P className="text-danger">{errors.terms.message}</P>
            )}
            <Btn
              type="submit"
              style={{
                backgroundImage:
                  'linear-gradient(223deg, #FFAF00 45%, #FF3500 100%)',
              }}
              color="primary"
              className="w-100 mt-3"
              block
              disabled={loading}
            >
              {loading ? 'Registering...' : CreateAccount}
            </Btn>
          </FormGroup>
        </Form>

        <P style={{ color: '#ff7a18' }} className="mt-4 mb-0 text-center">
          {AlreadyHaveAccount}
          <Link className="ms-2" to="/login">
            {SignIn}
          </Link>
        </P>
      </div>
    </div>
  );
}
